// @ts-ignore
/* eslint-disable */
import request from '../../utils/request';

/** 更新rta链路信息 # **获取AccessToken** 
<a href='http://auth-service-beta2.shrise.cn/doc.html#/default/token-controller/generateUserAccessTokenUsingPOST' target='_blank'>点击此处获取测试站用户AccessToken</a>参数示例: 
  ```
{
  "productType": 171,
  "userId": 240
}
  ```
 POST /rta-event/update-trace */
export async function rtaEventUpdateTraceUsingPOST(
  body: API.RtaTraceReq,
  options?: { [key: string]: any },
) {
  return request<API.BaseResultVoid>('/rta-event/update-trace', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}
